import pro1 from "../assets/pro1.jpg";
import pro2 from "../assets/pro2.jpg";
import pro3 from "../assets/pro3.jpg";


const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "e-Konsulta",
        text: "A health management system that helps streamline medical requests, health records, and aid tracking in remote communities.",
        view: "/e_konsulta.pdf"
    },
    {
        imgsrc: pro2,
        title: "Roundy Bites",
        text: "A sales and ordering system that streamlines order processing, receipt printing, and sales tracking for food businesses.",
        view: "/roundy_bites.pdf"
    },
    {
        imgsrc: pro3,
        title: "Cipherion",
        text: "A cryptographic algorithm system that encrypts and decrypts data to protect sensitive information, ensuring secure communication and data integrity.",
        view: "/cipherion.pdf"
    }
]

export default ProjectCardData